import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import s from './index.module.scss';

export const OffersMobile = ({ data }) => {
  if (!data) return null;

  if (data.length === 1) {
    return data[0];
  }

  return (
    <div className={s.wrapper}>
      <Swiper slidesPerView="auto" spaceBetween={16} className={s.swiper}>
        {data.map((card, index) => (
          <SwiperSlide key={index} className={s.slide}>
            {card}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
